class Row extends React.Component {
  render () {
    const {permission, checked} = this.props
    return (
      <div className='col-lg-12'>
        <div className={'checkbox checkbox-primary'}>
          <input
            type='checkbox'
            id={permission.id}
            onChange={this._onChangeCheckbox}
            checked={checked}
          />
          <label
            for={permission.id}
          >
            {permission.sub_menu === 'Edit and Remove Open Bills' || permission.sub_menu === 'Manage Charge'
              ? permission.sub_menu + '*' : permission.sub_menu}
          </label>
        </div>
      </div>
    )
  }

  _onChangeCheckbox = () => {
    const {disabled} = this.props
    if (!disabled) {
      this.props.onChangeCheckbox(this.props.permission)
    }
  }
}

export default Row



// WEBPACK FOOTER //
// ./app/pages/Employees/Role/RoleDetail/RoleForm/AccessAppPermission/Row.js